
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { CagnotteService } from '../../../shared/services/cagnotte.service';
import { AssociationService } from '../../../shared/services/association.service';

import { Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export class CagnottesDetailsResolver implements Resolve<any[]> {

  constructor(@Inject(CagnotteService) private cagnotteService: CagnotteService,
    @Inject(AssociationService) private associationService: AssociationService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
    return observableForkJoin(this.cagnotteService.findById(+route.paramMap.get('id')),
      this.associationService.list());
  }
}
